/**
 * List of endpoints.
 */
export const endpoints = {
  GET_PUBLIC_CONFIG: '/api/public/configs/:code',
  POST_SET_CONFIG: '/api/configs',
};
